<div class="sb-ticket--banner background-color-muted" (click)="openBonus()">
  <span class="sb-ticket--banner-title text-center color-light"
    >Mejorada
    <span class="text-big">+{{ currentPercentage }}%</span>
  </span>
  <span class="sb-ticket--banner-subtitle color-dark">Mejora tu premio aplicado</span>
  <ion-icon name="alert-circle-outline" class="color-grey-700 icon icon-md ion-md-search" role="img" aria-label="alert">
  </ion-icon>
</div>
